module.exports = __webpack_public_path__ + "img/wh.280d8397.png";